// src/pages/PublicForm.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FormPreview from './FormPreview';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PdfIcon from '@mui/icons-material/PictureAsPdf';

const FormLink = () => {
  const appToken = useSelector((state) => state.appToken.apptoken);
  const userData = useSelector((state) => {
    const reduxData = state?.loginData?.loginData;
    
    if (!reduxData || !reduxData.id) {
      // Önce form kullanıcısı verilerini kontrol et
      const formUserData = localStorage.getItem('formUserData');
      if (formUserData) {
        try {
          return JSON.parse(formUserData);
        } catch (error) {
          console.error('Error parsing localStorage formUserData:', error);
        }
      }
      
      // Eğer form kullanıcısı verisi yoksa, panel kullanıcısı verilerini kontrol et
      const localUserData = localStorage.getItem('userData');
      if (localUserData) {
        try {
          return JSON.parse(localUserData);
        } catch (error) {
          console.error('Error parsing localStorage userData:', error);
        }
      }
    }
    
    return reduxData;
  });
  const { formId } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleFormSubmit = async (formData) => {
    try {
      // Kullanıcı bilgilerini al
      const userInfo = {
        id: userData?.id,
        name: userData?.userData?.name || userData?.username || 'Kullanıcı',
        email: userData?.userData?.email || userData?.username || '',
        categories: userData?.userData?.categories,
        isActive: userData?.userData?.isActive !== false,
        token: userData?.userData?.token || userData?.token
      };

      // Form verilerini hazırla
      const submissionData = {
        formId: formId.toString(),
        formContent: {
          id: parseInt(formId),
          title: formData.title,
          description: formData.description,
          fields: formData.fields,
          formData: formData.formData,
          settings: formData.settings
        },
        formData: {
          formId: formId.toString(),
          formData: formData.formData
        },
        userId: userInfo.id || 0,
        user: userInfo.name || userInfo.email || 'Kullanıcı' // Kullanıcı adını string olarak gönder
      };

      console.log('Gönderilecek veri:', submissionData);

      const response = await axios.post(
        'https://app.hhoms.com/api/form/LibraryRecords',
        submissionData,
        {
          headers: {
            'Content-Type': 'application/json',
             ApplicationToken: appToken,
          }
        }
      );

      if (response.status === 200) {
        console.log('Form başarıyla gönderildi:', response.data);
        return true;
      }
    } catch (error) {
      console.error('Form gönderme hatası:', error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://app.hhoms.com/api/form/Libraries/${formId}`, {
          headers: {
            ApplicationToken: appToken,
          },
        });

        console.log('API Response:', response.data);

        if (response.data.formLibraries && response.data.formLibraries[0]) {
          const formContent = response.data.formLibraries[0].formContent;
          let parsedData;
          
          try {
            parsedData = JSON.parse(formContent);
            console.log('FormData (tam yapı):', parsedData);
            
            // Hesaplama alanı değerlerini çıkar
            const calculationValues = {};
            parsedData.fields.forEach(field => {
              if (field.type === 'calculation' && field.calculationData) {
                calculationValues[field.id] = field.calculationData;
              }
            });

            // Dosya alanlarını kontrol et ve düzenle
            if (parsedData.fields) {
              parsedData.fields = parsedData.fields.map(field => {
                if (field.type === 'file' || field.type === 'image') {
                  return {
                    ...field,
                    accept: field.type === 'image' 
                      ? 'image/jpeg,image/png,image/gif,image/webp,image/bmp,image/tiff'
                      : '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip,.rar,.7z',
                    maxSize: 1024 * 1024 * 1024 // 1GB
                  };
                }
                return field;
              });
            }
            
            setFormData({
              ...parsedData,
              calculationValues
            });
            console.log('FormData Fields:', parsedData.fields);
            console.log('FormData Settings:', parsedData.settings);
          } catch (parseError) {
            console.error('Form içeriği parse edilemedi:', parseError);
            setError('Form içeriği geçersiz format');
          }
        } else {
          setError('Form bulunamadı veya yayınlanmamış');
        }
      } catch (err) {
        console.error('Form yüklenirken bir hata oluştu:', err);
        setError('Form yüklenirken bir hata oluştu: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [formId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {formData && (
        <FormPreview
          id="form-preview"
          formTitle={formData.title}
          formDescription={formData.description}
          formFields={formData.fields}
          settings={formData.settings}
          logoUrl={formData.logo}
          calculationValues={formData.calculationValues}
          onSubmit={handleFormSubmit}
        />
      )}
      {/* <Button
        startIcon={<PdfIcon />}
        onClick={() => navigate(`/forms/${formId}/pdf`)}
      >
        PDF Oluştur
      </Button> */}
    </Box>
  );
};

export default FormLink;